import { connect } from 'react-redux';

import { Instances } from '../../../constants';
import { FilterType } from '../../../interface';
import { IStateType } from '../../../store/models/root.interface';
import {
	makeSelectFilters,
	changeFilters as objectChangeFilters,
	makeSelectObject,
} from '../../../store/Object';
import {
	changeFilters, changeSearchStr
} from '../../../store/Objects'

import Overview, { MapStateType, DispatchPropsType } from '../organisms/Overview/SeeMore';
import { BaseSeeMorePropsType } from '../templates/SeeMoreModal';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { setOverviewFilter } from '../../../store/actions/dashboard.action';

const mapStateToProps = (state: IStateType) => ({
	filters: makeSelectFilters(Instances.smsOverview)(state),
	smsOverview: makeSelectObject(Instances.smsOverview)(state)
});

const mapDispatchToProps = (dispatch: any) => ({
	onFilterChange: (filter: FilterType) => {
		dispatch(
			objectChangeFilters(Instances.smsOverview, filter)
		);
		dispatch(
			changeFilters(Instances.smsOverviewSeeMore, filter)
		);
		// dispatch(
		// 	objectChangeFilters(Instances.whatsappOverview, filter)
		// );
		// dispatch(
		// 	changeFilters(Instances.whatsappOverviewSeeMore, filter)
		// )
	},
	setFilterKey: (filterKey: string) => dispatch(setOverviewFilter(filterKey)),
	onSearchChange: (instanceId: Instances, searchStr: string) => dispatch(changeSearchStr(instanceId, searchStr))
});

export default connect<MapStateType, DispatchPropsType, BaseSeeMorePropsType, IStateType>(
	mapStateToProps,
	mapDispatchToProps
)(withImmutablePropsToJS(Overview));
